var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-3"},[_c('strong',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.text))]),_c('v-divider',{staticClass:"mb-1"}),_c('div',{staticClass:"text-uppercase font-weight-light text-xs-center"},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }